import { initial, last } from 'lodash';

export function toSnakeCase(str: string): string {
    return str
        .replace(/(?:^\w|[A-Z]|\b\w)/g, (word, index) => {
            return index === 0 ? word.toLowerCase() : '_' + word.toLowerCase();
        })
        .replace(/\s+/g, '');
}

export function formatLargeNumber(
    value: number,
    decimals: number = 2,
    decimalPoint: string = '.',
    thousandsSeparator: string = ' ',
): string {
    const parts = value.toFixed(decimals).split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandsSeparator);
    return parts.join(decimalPoint);
}

export function joinWithDifferentLastSeparator(
    items: Array<string>,
    finalSeparator = 'and',
): string {
    return items.length
        ? items.length == 1
            ? items[0]
            : `${initial(items).join(', ')} ${finalSeparator} ${last(items)}`
        : '';
}
